module.exports = __webpack_public_path__ + "img/id.ddde7a4d.png";